export enum StateStatus {
    PENDING = 'pending',
    SUCCESS = 'success',
    COMPLETE = 'complete',
    ERROR = 'error',
}
